import { Component } from '@angular/core';
import { PageShellComponent } from '../../core/layout/page-shell.component';
import { HeroComponent } from './hero.component';
import { ReferralPromoBandComponent } from './referral-promo-band.component';
import { CapabilityStripComponent } from './capability-strip.component';
import { SolutionsComponent } from './solutions.component';
import { ProcessComponent } from './process.component';
import { TrackRecordComponent } from './track-record.component';
import { ContactSectionComponent } from './contact-section.component';

@Component({
  selector: 'hx-home-page',
  standalone: true,
  imports: [
    PageShellComponent,
    HeroComponent,
    ReferralPromoBandComponent,
    CapabilityStripComponent,
    SolutionsComponent,
    ProcessComponent,
    TrackRecordComponent,
    ContactSectionComponent,
  ],
  template: `
    <hx-page-shell>
      <hx-hero></hx-hero>
      <hx-referral-promo-band></hx-referral-promo-band>
      <hx-capability-strip></hx-capability-strip>
      <hx-solutions></hx-solutions>
      <hx-process></hx-process>
      <hx-track-record></hx-track-record>
      <hx-contact-section></hx-contact-section>
    </hx-page-shell>
  `,
})
export class HomePageComponent {}
